import { formatDate, nextMonth } from '@/utils/time';

export const auth = {
  username: window.location.hostname === 'localhost' ? '97939898' : null,
  password: window.location.hostname === 'localhost' ? 'creative12' : null,
};

export const twoFA = {
  code: null,
};

export const profile = {
  email: null,
  first_name: null,
  last_name: null,
  mobile: null,
  medical_conditions: [],
  scalp_conditions: [],
};

export const media = {
  date: formatDate(new Date(), 'dd/MM/yyyy'),
  name: null,
  media: null,
};

export const password = {
  password: null,
  password_confirmation: null,
};

export const shop = {
  address: '',
  country: 'Singapore',
  name: '',
  telephone_no: '',
};

export const user = {
  email: null,
  first_name: null,
  last_name: null,
  mobile: null,
  medical_conditions: [],
  scalp_conditions: [],
  password:
    Math.random()
      .toString(36)
      .substring(4, 8) +
    Math.random()
      .toString(36)
      .substring(4, 8),
  role: 'customer',
  shop_id: null,
};
